// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v51g","label":"styles_label__38BSp"};